// Dependencias generales
import React, { useRef } from "react";
import { useEffect, useState } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader'
import StepIntro from '../../../components/InitialConfig/StepIntro'
import AsideMenu from '../../../components/InitialConfig/AsideMenu'
import AppLogoImg from '../../../components/Utils/AppLogoImg'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons'
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration"
import FormValidationError from "../../../components/InitialConfig/FormValidationError"
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"
const putAccountIDInstallation = endpointHelias+'/Helias/V0/Configuration/putAccountIDInstallation'
const postPDFtoConfigData = endpointHelias+'/Helias/V0/Configuration/postPDFtoConfigData'

//const urlJsonMunicipios = "https://www.fevergy.com/json/Municipios.json" //Producción
//const urlJsonMunicipios = "https://helias.fevergy.com/json/Municipios.json" //Prueba local 
const urlJsonMunicipios = "/json/Municipios.json" //Prueba local 
const urlJsonCodigosPostalesMunicipios = "/json/CP_to_Location_Compact.json" //Prueba local 

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var generalCommonJS = require("../../../js/generalCommon.js")

var municipios = []
var codigosPostales = []

// Initial config - GeneralInfo
const GeneralInfo = () => {
  
  const [appSensorAP1, setAppSensorAP1] = useState("")
  const [appSensorAP2, setAppSensorAP2] = useState("")
  const [appSensorAP3, setAppSensorAP3] = useState("")  
  const [illustrationElements, setIllustrationElements] = useState([])

  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "40.4167754", long: "-3.7037902" }]) //Default Madrid  

  useEffect(() => {     
    
    if(initialConfigCommonJS.antiBackOnboarding() === false){
  
      if(localStorage.getItem("installationConfigurationMode") === null){
        
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")        
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - GENERAL INFO', "", "")
      }      

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("GENERAL_INFO_USER")    
            
      document.getElementById("acometidaPrincipal2FieldsetSinConfigurar").className = document.getElementById("acometidaPrincipal2FieldsetSinConfigurar").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("acometidaPrincipal3FieldsetSinConfigurar").className = document.getElementById("acometidaPrincipal3FieldsetSinConfigurar").className.replaceAll(" hidden", "") + " hidden"

      cargarCodigosPostales()
      cargarMunicipios()    

      if(localStorage.getItem("currentInstallationConfiguration") !== null){        
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))        
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"        
      }
      else{
        cargarConfiguracionActualPaso()        
      }
      
      
      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("sectionGeneralInfo").className = "step"        
        initialConfigCommonJS.visibilidadModoConfiguracion()
      }
      else{
        document.title = "HELIAS - Configuración inicial: Información general"
      }

      if(localStorage.getItem("autoScrollBottom") !== null){            
        document.getElementById("contenedorPrincipalOpcion").scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
        localStorage.removeItem("autoScrollBottom")
      }

    }

  }, []);

  function procesarConfiguracionActual(jsonRespuesta){

    if(typeof jsonRespuesta.GeneralInfo !== 'undefined'){
              
      if (jsonRespuesta.GeneralInfo.toString().length > 0){
        
        var configuracionPasoActual = jsonRespuesta.GeneralInfo
        
        if(configuracionPasoActual.InstallationAddress !== undefined){

          try{
            document.getElementById("direccion").value = configuracionPasoActual.InstallationAddress                     
          }
          catch(error){            
            setTimeout(function() {
              try{
                document.getElementById("direccion").value = configuracionPasoActual.InstallationAddress                     
              }
              catch(error){
                window.location.reload()
              }
            }, (1 * 1000));                        
          }

        }
        else {
          document.getElementById("direccion").value = ""
          document.getElementById("direccion").placeholder = " "
        }

        document.getElementById("selectTipoInstalacion").value = configuracionPasoActual.InstallationType      

        document.getElementById("selectTipoSistemaElectricoInstalacion").value = configuracionPasoActual.ElectricSystemType      
        actualizarFormularioSensores()
   

        document.getElementById("nombreInstalacion").value = configuracionPasoActual.InstallationName      

        document.getElementById('municipio').value = configuracionPasoActual.InstallationLocationName
        document.getElementById('codigoPostal').value = configuracionPasoActual.InstallationZipCode

        document.getElementById("idMunicipioActual").value = configuracionPasoActual.InstallationLocationId+"|"+configuracionPasoActual.InstallationLocationLatitude+"|"+configuracionPasoActual.InstallationLocationLongitude

        if(configuracionPasoActual.PowerContracted !== ""){

          if(configuracionPasoActual.PowerContracted.split("#").length === 1){
            if(configuracionPasoActual.PowerContracted.includes("|")){
              initialConfigCommonJS.mostrarPotenciaEnTabla(configuracionPasoActual.PowerContracted)                      
            }
            else{
              //Muestro valores legacy
            }                    
          }
          else{
            initialConfigCommonJS.mostrarPotenciaEnTabla(configuracionPasoActual.PowerContracted)
          }
          
        }
        else{                  
          document.getElementById("tablaPotenciaContratada").className = document.getElementById("tablaPotenciaContratada").className + " hidden"                  
        }                

        document.getElementById("potenciaContratada").value = configuracionPasoActual.PowerContracted
        document.getElementById("potenciaActualConfigurada").value = configuracionPasoActual.PowerContracted

        
        if(document.getElementById("potenciaContratada").value !== ""){          
          document.getElementById("datosManualesPotenciaTarifas").setAttribute("open", "")
        }
        else{          
          document.getElementById("datosManualesPotenciaTarifas").removeAttribute('open');
        }

        if(configuracionPasoActual.EnergyBuyPrice !== ""){

          document.getElementById("fieldsetSelectTarifa").className = document.getElementById("fieldsetSelectTarifa").className.replaceAll(" hidden", "") + " hidden"

          if(configuracionPasoActual.EnergyBuyPrice === "OCTOPUS-FLEXI"){

            document.getElementById("fieldsetSelectTarifa").className = document.getElementById("fieldsetSelectTarifa").className.replaceAll(" hidden", "")

            document.getElementById("precioCompraKw").value = configuracionPasoActual.EnergyBuyPrice

            document.getElementById("theadTarifasEnergia").className = document.getElementById("theadTarifasEnergia").className.replaceAll(" hidden", "")
            document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "")     

            document.getElementById("trTarifaEnergiaP1").className = document.getElementById("trTarifaEnergiaP1").className.replaceAll(" hidden", "")
            document.getElementById("trTarifaEnergiaP2").className = document.getElementById("trTarifaEnergiaP2").className.replaceAll(" hidden", "")
            document.getElementById("trTarifaEnergiaP3").className = document.getElementById("trTarifaEnergiaP3").className.replaceAll(" hidden", "")

            document.getElementById("tarifaEnergiaP1").innerHTML = "Octopus Flexi"
            document.getElementById("tarifaEnergiaP2").innerHTML = "Octopus Flexi"
            document.getElementById("tarifaEnergiaP3").innerHTML = "Octopus Flexi"

          }
          else if(configuracionPasoActual.EnergyBuyPrice === "LUCERA-VARIABLE"){

            document.getElementById("fieldsetSelectTarifa").className = document.getElementById("fieldsetSelectTarifa").className.replaceAll(" hidden", "")

            document.getElementById("precioCompraKw").value = configuracionPasoActual.EnergyBuyPrice

            document.getElementById("theadTarifasEnergia").className = document.getElementById("theadTarifasEnergia").className.replaceAll(" hidden", "")
            document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "")     

            document.getElementById("trTarifaEnergiaP1").className = document.getElementById("trTarifaEnergiaP1").className.replaceAll(" hidden", "")
            document.getElementById("trTarifaEnergiaP2").className = document.getElementById("trTarifaEnergiaP2").className.replaceAll(" hidden", "")
            document.getElementById("trTarifaEnergiaP3").className = document.getElementById("trTarifaEnergiaP3").className.replaceAll(" hidden", "")

            document.getElementById("tarifaEnergiaP1").innerHTML = "Lucera - A precio de coste"
            document.getElementById("tarifaEnergiaP2").innerHTML = "Lucera - A precio de coste"
            document.getElementById("tarifaEnergiaP3").innerHTML = "Lucera - A precio de coste"

          }
          else{ // FIJA
            document.getElementById("theadTarifasEnergia").className = document.getElementById("theadTarifasEnergia").className.replaceAll(" hidden", "")
            initialConfigCommonJS.mostrarTarifasEnTabla(configuracionPasoActual.EnergyBuyPrice)
          }

        }
        else{                  
          document.getElementById("fieldsetSelectTarifa").className = document.getElementById("fieldsetSelectTarifa").className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("theadTarifasEnergia").className = document.getElementById("theadTarifasEnergia").className.replaceAll(" hidden", "") + " hidden"                  
          document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "") + " hidden"                            
        }

        if(configuracionPasoActual.VariableBuyPrice === "true"){
          document.getElementById("checkboxPrecioCompraVariable").checked = true
        }
        else{                  
          document.getElementById("checkboxPrecioCompraVariable").checked = false
        }

        visibilidadTarifasUltimoRecurso()

        document.getElementById("precioCompraKw").value = configuracionPasoActual.EnergyBuyPrice

        document.getElementById("descuentoEnFactura").value = configuracionPasoActual.BillDiscount

        document.getElementById("diaInicioFacturacion").value = configuracionPasoActual.BillingStartDay

        if(document.getElementById("diaInicioFacturacion").value === ""){
          console.log("Inicializo")
          document.getElementById("diaInicioFacturacion").value = "1"
        }

        //Cargo la combo del sensor de la acometida
        if(configuracionPasoActual.MainElectricConnectionSensor1 !== ""){
          var datosSensorAcometidaPrincipal1 = configuracionPasoActual.MainElectricConnectionSensor1.split("|")              
          setAppSensorAP1(datosSensorAcometidaPrincipal1[0]) 
          document.getElementById("acometidaPrincipal1Span").innerHTML = datosSensorAcometidaPrincipal1[datosSensorAcometidaPrincipal1.length-1]
          document.getElementById("acometidaPrincipal1").value = datosSensorAcometidaPrincipal1[0]+"|"+datosSensorAcometidaPrincipal1[1]+"|"+datosSensorAcometidaPrincipal1[2]  
          document.getElementById("acometidaPrincipal1FieldsetSinConfigurar").style="display: none"
          document.getElementById("acometidaPrincipal1FieldsetSeleccionado").style="display"
        }   

        if(configuracionPasoActual.MainElectricConnectionSensor2 !== ""){
          var datosSensorAcometidaPrincipal2 = configuracionPasoActual.MainElectricConnectionSensor2.split("|")              
          setAppSensorAP2(datosSensorAcometidaPrincipal2[0]) 
          document.getElementById("acometidaPrincipal2Span").innerHTML = datosSensorAcometidaPrincipal2[datosSensorAcometidaPrincipal2.length-1]
          document.getElementById("acometidaPrincipal2").value = datosSensorAcometidaPrincipal2[0]+"|"+datosSensorAcometidaPrincipal2[1]+"|"+datosSensorAcometidaPrincipal2[2]  
          document.getElementById("acometidaPrincipal2FieldsetSinConfigurar").style="display: none"
          document.getElementById("acometidaPrincipal2FieldsetSeleccionado").style="display"
        }   

        if(configuracionPasoActual.MainElectricConnectionSensor3 !== ""){
          var datosSensorAcometidaPrincipal3 = configuracionPasoActual.MainElectricConnectionSensor3.split("|")              
          setAppSensorAP3(datosSensorAcometidaPrincipal3[0]) 
          document.getElementById("acometidaPrincipal3Span").innerHTML = datosSensorAcometidaPrincipal3[datosSensorAcometidaPrincipal3.length-1]
          document.getElementById("acometidaPrincipal3").value = datosSensorAcometidaPrincipal3[0]+"|"+datosSensorAcometidaPrincipal3[1]+"|"+datosSensorAcometidaPrincipal3[2]  
          document.getElementById("acometidaPrincipal3FieldsetSinConfigurar").style="display: none"
          document.getElementById("acometidaPrincipal3FieldsetSeleccionado").style="display"
        }   

        if(configuracionPasoActual.EnergyGridConnected === "true"){                  
          document.getElementById("instalacionConectada").checked = true;
          document.getElementById("instalacionDesconectada").checked = false;        
          mostrarPestañaTipoInstalacion("CONECTADA")                    
        }
        else{                  
          document.getElementById("instalacionConectada").checked = false;
          document.getElementById("instalacionDesconectada").checked = true;                  
          mostrarPestañaTipoInstalacion("DESCONECTADA")       
        }  

      } 
      else{//Si es la primera vez que cargo sin inicializar...
        mostrarPestañaTipoInstalacion("CONECTADA")                               
      }               

      setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))              

    }  
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  
            procesarConfiguracionActual(jsonRespuesta.body)
            
            //Si no hay datos configurados entonces no hago nada  
            console.log("Configuración existente en BBDD cargada correctamente")

          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);      
  }
  
  function cargarMunicipios(){
  
    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", urlJsonMunicipios, true);    
    xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaMunicipios = JSON.parse(this.responseText)
          console.log("JSON de Municipios cargado correctamente")        
          var jsonMunicipios = JSON.parse(jsonRespuestaMunicipios.body.replaceAll("'", '"'))
  
          if(jsonMunicipios.length > 0){
            for (var i = 0; i < jsonMunicipios.length; i++) {
              municipios.push(jsonMunicipios[i].nombreMunicipio+"|"+jsonMunicipios[i].idMunicipio+"|"+jsonMunicipios[i].latitud+"|"+jsonMunicipios[i].longitud); 
            }  
          }                          

          console.log("Municipios cargados correctamente")
  
        }
        if (this.readyState === 4 && this.status !== 200) {                
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }            
    };
    xhttp.send();  
  
  }	
    
  function cargarCodigosPostales(){
  
    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", urlJsonCodigosPostalesMunicipios, true);    
    xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          codigosPostales = JSON.parse(this.responseText)         
          console.log("Códigos postales cargados correctamente")
        }
        if (this.readyState === 4 && this.status !== 200) {                
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }            
    };
    xhttp.send();  
  
  }	
  
  function mostrarPestañaTipoInstalacion(pestaña){

    actualizarFormularioSensores()
    
    if(pestaña === "CONECTADA"){      
      document.getElementById("instalacionConectada").checked = true
      document.getElementById("instalacionDesconectada").checked = false
      document.getElementById("fieldsetInstalacionConectada").className = ""              

      setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "GRID_CONNECTED"))
    }
    else{
      document.getElementById("instalacionConectada").checked = false    
      document.getElementById("instalacionDesconectada").checked = true
      document.getElementById("fieldsetInstalacionConectada").className = "hidden"                 
      setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "quitar", "GRID_CONNECTED"))
    }

    if(document.getElementById("acometidaPrincipal1").value !== "" ){
      document.getElementById("fieldsetInstalacionConectada").className = document.getElementById("fieldsetInstalacionConectada").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("fieldsetInstalacionConectada").className = document.getElementById("fieldsetInstalacionConectada").className + " hidden"
    }

  }

  function validacionCamposCorrecta(){

    actualizarMunicipio()

    var numeroErroresValidacion = 0

    document.getElementById("nombreInstalacion").className = ""      
    document.getElementById("direccion").className = ""             
    document.getElementById("diaInicioFacturacion").className = ""    
    document.getElementById("botonConfigurarPotencia").className = "button tertiary"    
    document.getElementById("botonConfigurarTarifas").className = "button tertiary"    
    document.getElementById("acometidaPrincipal1AddSensorLink").className = "link"    
    
    if(document.getElementById("nombreInstalacion").value === ""){
      numeroErroresValidacion++
      document.getElementById("nombreInstalacion").className = "error"
    }

    if( (document.getElementById("direccion").value === "") || (document.getElementById("municipio").value === "") || (document.getElementById("codigoPostal").value === "") || (document.getElementById("idMunicipioActual").value === "")){      
      numeroErroresValidacion++
      document.getElementById("direccion").className = "error"
    }

    if(document.getElementById("acometidaPrincipal1").value === ""){
      numeroErroresValidacion++
      document.getElementById("acometidaPrincipal1AddSensorLink").className = document.getElementById("acometidaPrincipal1AddSensorLink").className.replaceAll(" error","") + " error"
    }

    var validarDatosFactura = true

    if(document.getElementById("instalacionConectada").checked === false){
      validarDatosFactura = false
    }

    if(validarDatosFactura){

      if( (document.getElementById("potenciaContratada").value === "") || (document.getElementById("potenciaContratada").value === "0") ){
        numeroErroresValidacion++
        document.getElementById("botonConfigurarPotencia").className = "button secondary delete"
      }

      if( (document.getElementById("precioCompraKw").value === "") && (document.getElementById("checkboxPrecioCompraVariable").checked === false) ){
        numeroErroresValidacion++
        document.getElementById("botonConfigurarTarifas").className = "button secondary delete"
      }
    }

    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"      
      document.getElementById("datosManualesPotenciaTarifas").setAttribute("open", "")
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      document.getElementById("datosManualesPotenciaTarifas").removeAttribute('open');
      return true
    }

  }

  function actualizarNombreInstalacionEnSelector(nuevoNombre){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  
    if (lastAuthUser !== null){  
  
      var instalacionesDisponibles = localStorage.getItem("availableInstallations").split("|")      
      var instalacion = ""
      var idInstalacionActual = localStorage.getItem("installationId")
      var instalacionPremodificacion = ""
      var instalacionPostmodificacion = ""
      var nombreAntiguo = ""

      //Primero actualizo la combo
      
      for (var i = 0; i < instalacionesDisponibles.length; i++) {
        instalacion = instalacionesDisponibles[i].split("·")

        // Instalación: [0]iDInstalación·[1]NombreInstalacion·[2]EstadoInstalacion
        if(idInstalacionActual === instalacion[0]){          
          nombreAntiguo = instalacion[1]
          instalacionPremodificacion = instalacion[0] + "·" + instalacion[1] + "·" + instalacion[2]
          instalacionPostmodificacion = instalacion[0] + "·" + nuevoNombre + "·" + instalacion[2]
          instalacion[1] = nuevoNombre          
          
          document.getElementById("radio"+i).innerHTML = nuevoNombre
        }

      }      

      //Y por último actualizo la variable del local storage
      localStorage.setItem("availableInstallations", localStorage.getItem("availableInstallations").replaceAll(instalacionPremodificacion, instalacionPostmodificacion))

      //Y actualizo el selector
      if(document.getElementById("nombreInstalacionActual") !== null){
        document.getElementById("nombreInstalacionActual").innerHTML = nuevoNombre.split("*")[1]

        //Y el listado de instalaciones
        var listadoInstalaciones = document.getElementById("divSelectorInstalacion").querySelectorAll("span")

        for(var x=0; x < listadoInstalaciones.length; x++){                
          if(listadoInstalaciones[x].id.includes("spanNombreInstalacion")){
            if(document.getElementById(listadoInstalaciones[x].id).innerHTML.includes(nombreAntiguo.split("*")[1])){
              document.getElementById(listadoInstalaciones[x].id).innerHTML = nuevoNombre.split("*")[1]
            }            
          }          
        }

      }
      
    }
    else{
      initialConfigCommonJS.gestionarRespuestaPeticionErronea("401")
    }

  }

  function guardarInformacionPaso(direccion){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
    document.getElementById("loaderGeneralInfo").className="loader overlay"

    var datosMunicipio = document.getElementById('idMunicipioActual').value.split("|") 
    var nombreMunicipio = document.getElementById('municipio').value  
  
    var conectadoARed  
    if(document.getElementById("instalacionDesconectada").checked){
      conectadoARed = false
      document.getElementById("potenciaContratada").value = ""
      document.getElementById("precioCompraKw").value = ""
    }
    else{
      conectadoARed = true
    }
    
    var automaticoPrincipal = ""
    
    var sensorAcometida1 = ""
    if(document.getElementById("acometidaPrincipal1").value !== ""){
      sensorAcometida1 = document.getElementById("acometidaPrincipal1").value+"|"+document.getElementById("acometidaPrincipal1Span").innerHTML
    }

    var sensorAcometida2 = ""
    var sensorAcometida3 = ""

    if (document.getElementById("selectTipoSistemaElectricoInstalacion").value === "TRIFASICO"){
      
      if(document.getElementById("acometidaPrincipal2").value !== ""){
        sensorAcometida2 = document.getElementById("acometidaPrincipal2").value+"|"+document.getElementById("acometidaPrincipal2Span").innerHTML
      }
      
      if(document.getElementById("acometidaPrincipal3").value !== ""){
        sensorAcometida3 = document.getElementById("acometidaPrincipal3").value+"|"+document.getElementById("acometidaPrincipal3Span").innerHTML
      }

    }   

    var porcentajeDescuento = document.getElementById("descuentoEnFactura").value

    var diaInicioFacturacion = document.getElementById("diaInicioFacturacion").value

    if(parseInt(porcentajeDescuento) === 0 ){
      porcentajeDescuento = ""
    }

    var precioCompraEnergia = document.getElementById("precioCompraKw").value

    var potenciaContratada = document.getElementById("potenciaContratada").value

    if(document.getElementById("instalacionConectada").checked === true){
      
      if (document.getElementById("acometidaPrincipal1").value !== "") {
        
        if (document.getElementById("potenciaContratada").value === "") {
          potenciaContratada = "0"
        }
                
      }
      else{ //Si no tengo monitor configurado guardo todo a ""
        potenciaContratada = ""
        precioCompraEnergia = ""
        porcentajeDescuento = ""
      }
            
    }    

    var tarifaCompraVariable = "false"

    if(document.getElementById("checkboxPrecioCompraVariable").checked === true){
      tarifaCompraVariable = "true"     
      precioCompraEnergia = "" 
    }

    var jsonGeneralInfo = {            
      "InstallationName": document.getElementById("nombreInstalacion").value,
      "InstallationAddress": document.getElementById("direccion").value,
      "InstallationZipCode": document.getElementById("codigoPostal").value,
      "InstallationLocationName": nombreMunicipio,
      "InstallationLocationId": datosMunicipio[0],
      "InstallationLocationLatitude": datosMunicipio[1],
      "InstallationLocationLongitude": datosMunicipio[2],    
      "InstallationType": document.getElementById("selectTipoInstalacion").value,      
      "ElectricSystemType": document.getElementById("selectTipoSistemaElectricoInstalacion").value,
      "EnergyGridConnected": conectadoARed.toString(),
      "PowerContracted": potenciaContratada.replaceAll(",","."),
      "VariableBuyPrice": tarifaCompraVariable,
      "EnergyBuyPrice": precioCompraEnergia.replaceAll(",","."),        
      "BillDiscount": porcentajeDescuento.replaceAll(",","."),
      "BillingStartDay": diaInicioFacturacion,
      "GeneralGridSwitch": automaticoPrincipal,
      "MainElectricConnectionSensor1": sensorAcometida1,
      "MainElectricConnectionSensor2": sensorAcometida2,
      "MainElectricConnectionSensor3": sensorAcometida3      
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": jsonGeneralInfo
    }

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", updateInstallationConfiguration, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonGuardado)
    xhttp.onreadystatechange = function() {
        
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuestaGuardado = JSON.parse(this.responseText)
        if( (jsonRespuestaGuardado.statusCode === "403") ||(jsonRespuestaGuardado.statusCode === "401") ){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{          
          
          var nombreInstalacion = ""

          //Actualizo el nombre de la instalación en BBDD sólo si estoy en modo de configuración
          if(localStorage.getItem("installationConfigurationMode") !== null){

            var xhttp2 = new XMLHttpRequest();
            xhttp2.open("PUT", putAccountIDInstallation, true);        
            xhttp2.setRequestHeader('Content-Type', "application/json");
            xhttp2.setRequestHeader('Authorization', lastAuthUserIdToken);
                
            var idInstalacion = localStorage.getItem("ongoingInstallationConfiguration")
  
            var pasoWorkflow 
            if(localStorage.getItem("installationConfigurationMode") === null){
              pasoWorkflow = localStorage.getItem("ongoingStepConfiguration")
            }
            else{
              var instalacionesDisponibles = localStorage.getItem("availableInstallations").split("|")
              for (var i = 0; i < instalacionesDisponibles.length; i++) {
                if(instalacionesDisponibles[i].includes(idInstalacion)){
                  var datosInstalacion = instalacionesDisponibles[i].split("·")
                  pasoWorkflow = datosInstalacion[2]
                }
              }
            }
  
            var elementosInstalacion
            if(localStorage.getItem('customizedWorkflow') !== null){ elementosInstalacion = localStorage.getItem('customizedWorkflow') }
            else{ elementosInstalacion = "" }
  
            nombreInstalacion = document.getElementById("selectTipoInstalacion").value + "*" + document.getElementById("nombreInstalacion").value
                      
            var data2 = JSON.stringify({
              "IdToken": lastAuthUserIdToken, 
              "idInstalacion": idInstalacion, 
              "estadoConfiguracionInicial": pasoWorkflow, 
              "elementosInstalacion": elementosInstalacion, 
              "nombreInstalacion": nombreInstalacion});        
            
            xhttp2.onreadystatechange = function() {
  
              if (this.readyState === 4 && this.status === 200) {        
                //Si la respuesta es correcta      
                console.log("Nombre de instalación actualizado correctamente.")
  
                localStorage.setItem("installationName", nombreInstalacion)
  
                //En caso de estar en modo configuración tras primera configuración actualizo el selector de instalación con el nuevo nombre
                if(localStorage.getItem("installationConfigurationMode") !== null){
                  actualizarNombreInstalacionEnSelector(nombreInstalacion)
                }    
  
                //Por último borro las variables innecesarias del local storage
                localStorage.removeItem("deviceToConfigure")
  
                console.log("Información guardada correctamente")
  
                document.getElementById("loaderGeneralInfo").className="loader hidden"
  
                // Y continuo a la siguiente página    
                if(localStorage.getItem("installationConfigurationMode") === null){

                  if(localStorage.getItem("ongoingStepConfiguration") === "GENERAL_INFO_USER"){      
                    localStorage.setItem("ongoingInstallationName", document.getElementById("nombreInstalacion").value)              
                    initialConfigCommonJS.navegarDinamico(direccion)
                  }
                  else{
                    initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
                  }
                }
                else{
                  initialConfigCommonJS.mostrarMensajeInformativo("Configuración guardada correctamente.","positive")
                  document.getElementById("asideDetalleConfiguracion").className += " hidden"

                  // Ahora compruebo si la modificación ha conllevado cambio de potencia contratada y en tal caso reseteo máximos y excesos.
                  var elementosPotenciaContratada = document.getElementById("potenciaContratada").value.split("#")
                  var elementosPotenciaActualConfigurada = document.getElementById("potenciaActualConfigurada").value.split("#")

                  var stringConfiguracionPotenciaContratada = ""
                  var stringConfiguracionPotenciaActualConfigurada = ""

                  for (var x=0; x < elementosPotenciaContratada.length; x++){
                    stringConfiguracionPotenciaContratada = stringConfiguracionPotenciaContratada + elementosPotenciaContratada[x].split("|")[0] + "|"
                  }

                  for (var y=0; y < elementosPotenciaActualConfigurada.length; y++){
                    stringConfiguracionPotenciaActualConfigurada = stringConfiguracionPotenciaActualConfigurada + elementosPotenciaActualConfigurada[y].split("|")[0] + "|"
                  }

                  if(stringConfiguracionPotenciaContratada !== stringConfiguracionPotenciaActualConfigurada){
                    initialConfigCommonJS.reiniciarMaximoHistorico()
                  }

                }
  
              }                        
              if (this.readyState === 4 && this.status !== 200) {                        
                module.exports.gestionarRespuestaPeticionErronea(this.status)                   
              }            
            };
            xhttp2.send(data2); 

          }
          else{ //Si estoy en modo onboarding seteo el valor en localstorage y dejo que lo guarde en BBDD "actualizarPasoWorkflowEnBBDD"
            
            nombreInstalacion = document.getElementById("selectTipoInstalacion").value + "*" + document.getElementById("nombreInstalacion").value
            
            console.log("Información guardada correctamente")
  
            // Y continuo a la siguiente página                
            if(localStorage.getItem("ongoingStepConfiguration") === "GENERAL_INFO_USER"){      
              localStorage.setItem("ongoingInstallationName", nombreInstalacion)      
              localStorage.setItem("installationName", nombreInstalacion)        
              initialConfigCommonJS.navegarDinamico(direccion)
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
            }            

          }
          
          
        }

      }
  
      if (this.readyState === 4 && this.status !== 200) {
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
      }
    }
    xhttp.send(data);      
  
  }

  function actualizarFormularioSensores(){

    if(document.getElementById("selectTipoSistemaElectricoInstalacion").value === "MONOFASICO"){
      document.getElementById("acometidaPrincipal1FieldsetSinConfigurar").className = document.getElementById("acometidaPrincipal1FieldsetSinConfigurar").className.replaceAll(" hidden", "")
      document.getElementById("acometidaPrincipal2FieldsetSinConfigurar").className += " hidden"
      document.getElementById("acometidaPrincipal3FieldsetSinConfigurar").className += " hidden"

      document.getElementById("acometidaPrincipal1FieldsetSeleccionado").className = document.getElementById("acometidaPrincipal1FieldsetSeleccionado").className.replaceAll(" hidden", "")
      document.getElementById("acometidaPrincipal2FieldsetSeleccionado").className += " hidden"
      document.getElementById("acometidaPrincipal3FieldsetSeleccionado").className += " hidden"

      document.getElementById("textoBoton1Monitor").innerHTML = 'Seleccionar dispositivo'
      document.getElementById("tituloAcometidaFase1Configurada").className = document.getElementById("tituloAcometidaFase1Configurada").className.replaceAll(" hidden","") + " hidden"

    }
    else{
      document.getElementById("acometidaPrincipal1FieldsetSinConfigurar").className = document.getElementById("acometidaPrincipal1FieldsetSinConfigurar").className.replaceAll(" hidden", "")
      document.getElementById("acometidaPrincipal2FieldsetSinConfigurar").className = document.getElementById("acometidaPrincipal2FieldsetSinConfigurar").className.replaceAll(" hidden", "")
      document.getElementById("acometidaPrincipal3FieldsetSinConfigurar").className = document.getElementById("acometidaPrincipal3FieldsetSinConfigurar").className.replaceAll(" hidden", "")

      document.getElementById("acometidaPrincipal1FieldsetSeleccionado").className = document.getElementById("acometidaPrincipal1FieldsetSeleccionado").className.replaceAll(" hidden", "")
      document.getElementById("acometidaPrincipal2FieldsetSeleccionado").className = document.getElementById("acometidaPrincipal2FieldsetSeleccionado").className.replaceAll(" hidden", "")
      document.getElementById("acometidaPrincipal3FieldsetSeleccionado").className = document.getElementById("acometidaPrincipal3FieldsetSeleccionado").className.replaceAll(" hidden", "")

      document.getElementById("textoBoton1Monitor").innerHTML = 'Seleccionar dispositivo para la Fase 1'

    }

  }

  function navegar(direccion){    
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){
        if(validacionCamposCorrecta()){
          if(document.getElementById("contenedorPrincipalOpcion") !== null){
            document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
          }
          guardarInformacionPaso(direccion)
        }
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "GENERAL_INFO_USER"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      } 
    }
  }

  function actualizarMunicipio(){
    
    if(document.getElementById("codigoPostal").value.length > 4){

      var idCodigoPostal = parseInt(document.getElementById("codigoPostal").value)
      var idMunicipio = codigosPostales[idCodigoPostal.toString()]

      //Si el municipio tiene menos de 5 digitos relleno con ceros a la izquierda
      var numeroCerosAIncluir = 5 - idMunicipio.length

      for(var c=0; c < numeroCerosAIncluir; c++){
        idMunicipio = "0"+idMunicipio.toString()
      }

      var coordenadas = document.getElementById("idMunicipioActual").value.split("|")             

      for(var x=0; x < municipios.length; x++){
        if(municipios[x].split("|")[1] === idMunicipio){          
          document.getElementById("municipio").value = municipios[x].split("|")[0]
          
          if(coordenadas[2] !== undefined){
            document.getElementById("idMunicipioActual").value = municipios[x].split("|")[1]+"|"+coordenadas[1]+"|"+coordenadas[2]
          }
          else{ //He modificado datos de dirección
            document.getElementById("idMunicipioActual").value = municipios[x].split("|")[1]+"|"+coordenadas[0]+"|"+coordenadas[1]            
          }

          break
        }
      }
    }

  }

  function calculadoraPotencia(){

    if(document.getElementById("potenciaContratada").value !== ""){
      for(var y=0; y<6; y++){
        document.getElementById("PotenciaP"+(y+1)).value = ""
        document.getElementById("precioPotenciaP"+(y+1)).value = ""
        document.getElementById("PotenciaP"+(y+1)).className = document.getElementById("PotenciaP"+(y+1)).className.replaceAll(" error","")
        document.getElementById("precioPotenciaP"+(y+1)).className = document.getElementById("precioPotenciaP"+(y+1)).className.replaceAll(" error","")

        if( y !== 0 ){
          document.getElementById("trPotenciaP"+(y+1)).className = document.getElementById("trPotenciaP"+(y+1)).className.replaceAll(" hidden", "") + " hidden"
        }
      }

      var configuracionActualPotencia = document.getElementById("potenciaContratada").value
      var elementosConfiguracionPotencia = configuracionActualPotencia.split("#")
      
      var elementoPotenciaTemp = ""

      for(var z=0; z<elementosConfiguracionPotencia.length; z++){

        elementoPotenciaTemp = elementosConfiguracionPotencia[z].split("|")

        document.getElementById("PotenciaP"+(z+1)).value = elementoPotenciaTemp[0]
        document.getElementById("precioPotenciaP"+(z+1)).value = elementoPotenciaTemp[1]
        document.getElementById("trPotenciaP"+(z+1)).className = document.getElementById("trPotenciaP"+(z+1)).className.replaceAll(" hidden", "")

      }

      if(elementosConfiguracionPotencia.length === 1){
        document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta | Llano | Valle"          
      }  

      if(elementosConfiguracionPotencia.length === 2){
        document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta | Llano"
        document.getElementById("spanCalculadoraPotenciaP2").innerHTML ="P2 : Valle"
      }  

      if(elementosConfiguracionPotencia.length === 6){
        document.getElementById("spanCalculadoraPotenciaP1").innerHTML = "P1 :"
        document.getElementById("spanCalculadoraPotenciaP2").innerHTML = "P2 :"
        document.getElementById("spanCalculadoraPotenciaP3").innerHTML = "P3 :"
        document.getElementById("botonAñadirPPotencia").className = document.getElementById("botonAñadirPPotencia").className.replaceAll(" hidden", "") + " hidden"
      }

    }
    else{
      if(document.getElementById("trPotenciaP2").className.includes(" hidden")){
        initialConfigCommonJS.añadirPPotencia()
      }
    }

    initialConfigCommonJS.operarMenuLateral("abrir")
    initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("divCalculadoraPotencia","noUpdate")  
        
  }

  function configurarSinDireccion(){    
    
    document.getElementById("divConfigurarSinDireccion").className = document.getElementById("divConfigurarSinDireccion").className.replaceAll(" hidden", "")

    initialConfigCommonJS.operarMenuLateral("abrir")   

    if(document.getElementById("idMunicipioActual").value !== ""){
     
      document.getElementById("direccionUbicacion").value = document.getElementById("direccion").value

      document.getElementById("codigoPostalUbicacion").value = document.getElementById("codigoPostal").value

      var coordenadas = document.getElementById("idMunicipioActual").value.split("|")             

      if(coordenadas[2] !== undefined){
        setSelectedLocation([{ id: "", distance: "", lat: coordenadas[1], long: coordenadas[2] }])
        document.getElementById("latitudUbicacion").value = coordenadas[1]
        document.getElementById("longitudUbicacion").value = coordenadas[2]
      }
      else{ //He modificado datos de dirección
        setSelectedLocation([{ id: "", distance: "", lat: coordenadas[0], long: coordenadas[1] }])
        document.getElementById("latitudUbicacion").value = coordenadas[0]
        document.getElementById("longitudUbicacion").value = coordenadas[1]
      }

    }

    initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("divConfigurarSinDireccion","noUpdate")  
  }

  function calculadoraTarifaCompra(){    

    var valorActualTarifas = document.getElementById("precioCompraKw").value   

    if(valorActualTarifas === "OCTOPUS-FLEXI"){

      document.getElementById("selectTarifa").value = valorActualTarifas

      initialConfigCommonJS.operarMenuLateral("abrir")
      initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("divCalculadoraTarifa","noUpdate")  
    }
    else if(valorActualTarifas === "LUCERA-VARIABLE"){

      document.getElementById("selectTarifa").value = valorActualTarifas

      initialConfigCommonJS.operarMenuLateral("abrir")
      initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("divCalculadoraTarifa","noUpdate")  
    }
    else{

      if(valorActualTarifas !== ""){
      
        for(var y=0; y<6; y++){      
          document.getElementById("precioP"+(y+1)).value = ""      
          document.getElementById("precioP"+(y+1)).className = document.getElementById("precioP"+(y+1)).className.replaceAll(" error","")

          if( y !== 0 ){
            document.getElementById("trP"+(y+1)).className = document.getElementById("trP"+(y+1)).className.replaceAll(" hidden", "") + " hidden"
          }
        }

        var configuracionActualTarifasCompra = document.getElementById("precioCompraKw").value
        var elementosConfiguracionTarifasCompra = configuracionActualTarifasCompra.split("#")
        
        for(var z=0; z<elementosConfiguracionTarifasCompra.length; z++){

          document.getElementById("precioP"+(z+1)).value = elementosConfiguracionTarifasCompra[z]  
          document.getElementById("trP"+(z+1)).className = document.getElementById("trP"+(z+1)).className.replaceAll(" hidden", "")

        }

        if(elementosConfiguracionTarifasCompra.length === 1){
          document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta | Llano | Valle"    
          
          if(document.getElementById("potenciaContratada").value.split("#").length === 6){
            document.getElementById("spanTarifasP1").innerHTML ="P1, P2, P3, P4, P5, P6 :"      
          }
          
        }

        if(elementosConfiguracionTarifasCompra.length === 2){
          document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta | Llano"          
          document.getElementById("spanTarifasP2").innerHTML ="P2 : Valle"          

          if(document.getElementById("potenciaContratada").value.split("#").length === 6){
            document.getElementById("spanTarifasP1").innerHTML ="P1 :"      
            document.getElementById("spanTarifasP2").innerHTML ="P2 :"              
          }

        }

        if(elementosConfiguracionTarifasCompra.length === 3){
          document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta"          
          document.getElementById("spanTarifasP2").innerHTML ="P2 : Llano"          
          document.getElementById("spanTarifasP3").innerHTML ="P3 : Valle"         
          
          if(document.getElementById("potenciaContratada").value.split("#").length === 6){
            document.getElementById("spanTarifasP1").innerHTML ="P1 :"      
            document.getElementById("spanTarifasP2").innerHTML ="P2 :"              
            document.getElementById("spanTarifasP3").innerHTML ="P3 :"         
          }
          
          document.getElementById("botonAñadirP").className = document.getElementById("botonAñadirP").className.replaceAll(" hidden", "") + " hidden"
        }
        
      }
      else{

        var configuracionActualPotencia = document.getElementById("potenciaContratada").value
        var elementosConfiguracionPotencia = configuracionActualPotencia.split("#")

        if(elementosConfiguracionPotencia.length > 2){ //3.0
          if( (document.getElementById("trP2").className.includes(" hidden")) && 
              (document.getElementById("trP3").className.includes(" hidden")) &&
              (document.getElementById("trP4").className.includes(" hidden")) && 
              (document.getElementById("trP5").className.includes(" hidden")) && 
              (document.getElementById("trP6").className.includes(" hidden"))
              ){
            initialConfigCommonJS.añadirPTarifa() // Meto fila 2
            initialConfigCommonJS.añadirPTarifa() // Meto fila 3
            initialConfigCommonJS.añadirPTarifa() // Meto fila 4
            initialConfigCommonJS.añadirPTarifa() // Meto fila 5
            initialConfigCommonJS.añadirPTarifa() // Meto fila 6
          }
        }
        else{ //2.0
          if( (document.getElementById("trP2").className.includes(" hidden")) && (document.getElementById("trP3").className.includes(" hidden")) ){
            initialConfigCommonJS.añadirPTarifa() // Meto fila 2
            initialConfigCommonJS.añadirPTarifa() // Meto fila 3
          }
        }        
      }

      document.getElementById("selectTarifa").value = "FIJA"
      initialConfigCommonJS.actualizarFormularioTarifasCombo()

      initialConfigCommonJS.operarMenuLateral("abrir")
      initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("divCalculadoraTarifa","noUpdate")  
    }
  }

  const inputRef = useRef();

  const handlePlaceChanged = () => { 
      const [ place ] = inputRef.current.getPlaces();

      if(place) { 
        try{
          for(var x=0; x < place.address_components.length; x++){
            if(place.address_components[x].types[0] === "postal_code"){
              document.getElementById("codigoPostal").value = place.address_components[x].long_name
              document.getElementById("idMunicipioActual").value = place.geometry.location.lat()+"|"+place.geometry.location.lng()
            }
          }          
          
        }
        catch (error){}
      } 
  }

  function visibilidadTarifasUltimoRecurso(){
    
    if(document.getElementById("checkboxPrecioCompraVariable").checked === true){
      document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "") + " hidden"
    }
    else{
      document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "")      
    }

  }

  function validarDiaInicioFacturacion(){
    var diaInicioFacturacion = parseInt(document.getElementById("diaInicioFacturacion").value)

    if(document.getElementById("diaInicioFacturacion").value !== ""){
      if( isNaN(diaInicioFacturacion) === false){      
        if( (diaInicioFacturacion < 1) || (diaInicioFacturacion > 31) ){
          initialConfigCommonJS.mostrarMensajeInformativo("Indica sólo el día [ 1 - 31 ]","negative")
        }            
      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("Sólo puedes introducir números en este campo","negative")
        document.getElementById("diaInicioFacturacion").value = ""
      }
    }
    
  }

  var pdfFacturaBase64 = ""

  function generarAdjuntoBase64() {
    
    try{
      var reader = new FileReader();
      var f = document.getElementById("pdfFactura").files; 
      
      reader.onloadend = function () {    
        pdfFacturaBase64 = reader.result        
      }

      reader.readAsDataURL(f[0]);
    }
    catch(error){}

  }

  function enviarPDF(){

    if(document.getElementById("pdfFactura").value !== ""){

      document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replace(" hidden", "")
      document.getElementById("loaderGeneralAplicacionLabel").innerHTML = "Autocompletando datos con tu factura"
      

      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
      var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  

      var listadoAdjuntos = []

      listadoAdjuntos.push({"adjunto1" : pdfFacturaBase64 })

      //Petición de datos para el paso actual
      var jsonPeticion = {            
        "accountID": localStorage.getItem("accountID"),
        "installationID": ongoingInstallationConfigurationID,
        "adjuntos": listadoAdjuntos
      }

      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postPDFtoConfigData, true);                
        xhttp.setRequestHeader('Content-Type', "application/json");      
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)

            if(jsonRespuesta.statusCode === "200"){                   

              // PowerContracted = "2|0.0932208#2|0.0252537"
              // EnergyBuyPrice = "0.2026953#0.1297056#0.093711"
              
              try{
                var configPotencia = jsonRespuesta.body.PowerContracted.replaceAll(",",".")                            
                var precioVariable = jsonRespuesta.body.VariableBuyPrice

                document.getElementById("potenciaContratada").value = configPotencia
                initialConfigCommonJS.mostrarPotenciaEnTabla(configPotencia)              

                if(precioVariable === "true"){
                  document.getElementById("checkboxPrecioCompraVariable").checked = true
                }
                else{                  
                  document.getElementById("checkboxPrecioCompraVariable").checked = false
                  var configTarifas = jsonRespuesta.body.EnergyBuyPrice.replaceAll(",",".")
                  document.getElementById("precioCompraKw").value = configTarifas
                  initialConfigCommonJS.mostrarTarifasEnTabla(configTarifas)
                }              

                visibilidadTarifasUltimoRecurso()

                document.getElementById("diaInicioFacturacion").value = jsonRespuesta.body.BillingStartDay
                document.getElementById("descuentoEnFactura").value = jsonRespuesta.body.BillDiscount

                initialConfigCommonJS.mostrarMensajeInformativo("Datos autocompletados correctamente.","positive")

                document.getElementById("datosManualesPotenciaTarifas").setAttribute("open", "")
              }
              catch(error){
                initialConfigCommonJS.mostrarMensajeInformativo("No pude procesar el documento, vuelve a intentarlo.","negative")                
              }
              
            }
            else{          
              initialConfigCommonJS.mostrarMensajeInformativo("Formato de archivo incorrecto, sólo pueden ser documentos PDF.","negative")
            }

            document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"            
            document.getElementById("loaderGeneralAplicacionLabel").innerHTML = ""            

          }
    
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data);    
      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("Debes adjuntar primero tu última factura.","negative")     
      }

      

  }  

  return (          
    <main id="divMainContenedorStep">
    
      <InitialConfigHeader step={"GENERAL_INFO"}/>

      <section id="sectionGeneralInfo" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">            
          
          <StepIntro 
            Title="Datos de tu instalación" 
            Intro={<>
            <p>Ponle un nombre a tu instalación y rellena la siguiente información. Y tranquil@, ningún dato se comparte con nadie.</p>            
            </>} 
          />

          <form onSubmit={e => { e.preventDefault(); }} autoComplete="off" noValidate> 
            <fieldset>

              <fieldset className="text">
                <label htmlFor="name">Nombre de la instalación</label>
                <input type="text" id="nombreInstalacion"/>
              </fieldset>

              <fieldset>

                <label className="has-tooltip" htmlFor="labelDireccion">
                  <span className="label tooltip-label">Dirección</span>
                  <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip bottom">
                      <span className="tooltip-container">
                        <p className="size-m tooltip-title">¿Por qué me pides la dirección?</p>
                        <p className="size-s">Porque se necesita para localizar la estación meteorológica más cercana. Si no quieres dar tu dirección exacta puedes poner un número o calle cercana y sería igualmente válido.</p>
                      </span>
                    </span>
                  </span>
                </label>
                
                <div className="text">
                  <LoadScript googleMapsApiKey={"AIzaSyAKzBBmfUcgXRb4q_uUmLtZDUS9aedgsX4"} libraries={["places"]}>
                    <StandaloneSearchBox
                        onLoad={ref => inputRef.current = ref}
                        placeholder=" "                        
                        onPlacesChanged={handlePlaceChanged}                        
                    >
                      <input
                          id="direccion"
                          type="text"
                          placeholder=""
                          onKeyDown={e => { 
                            document.getElementById("municipio").value = ""
                            document.getElementById("codigoPostal").value = ""
                            document.getElementById("idMunicipioActual").value = ""
                            if (e.keyCode === 13) {e.preventDefault(); }}                            
                          }                        
                      />
                    </StandaloneSearchBox>
                  </LoadScript>
                </div>
              </fieldset>

              <fieldset>
                <button id="botonUbicacionInstalacion" rel="noopener noreferrer" target="_self" className="link" onClick={() => configurarSinDireccion()}>¿No tienes dirección?</button>
              </fieldset>    

              <fieldset className="text hidden">      
                <input type="text" id="municipio"/>
                <input type="text" id="codigoPostal"/>
                <input type="text" id="idMunicipioActual"/> 
              </fieldset>

              <fieldset>
                <legend>Tipo de instalación</legend>
                
                <fieldset className="dropdown">                
                  <div className="icon-wrapper">
                    <select id="selectTipoInstalacion">
                      <option value="PISO">Piso</option>
                      <option value="CHALET">Chalet</option>
                      <option value="EMPRESA">Empresa</option>
                      <option value="COMUNIDAD">Comunidad de vecinos</option>                    
                    </select>
                  </div>
                </fieldset>           

                <label className="has-tooltip" htmlFor="labelTipoSistemaElectricoInstalacion">
                  <span className="label tooltip-label">Sistema eléctrico</span>
                  <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip bottom">
                      <span className="tooltip-container">
                        <p className="size-m tooltip-title">¿Qué sistema eléctrico tengo?</p>
                        <p className="size-s">Si no sabes qué es ni monofásico ni trifásico seguramente tengas una instalación común, que <strong>el 98% de las veces son monofásicas</strong>. Aun así si no lo tienes claro siempre puedes preguntarle a un electricista o instalador para que te lo confirme o hacer click en el siguiente enlace donde se explica con detalle.</p>
                        <a href="https://www.mipodo.com/blog/informacion/una-instalacion-monofasica-trifasica/#:~:text=La%20energ%C3%ADa%20monof%C3%A1sica%20es%20aquella,voltaje%20es%20de%20380%20voltios." target="_blank" className="link size-s"  rel="noopener noreferrer"><span className="material-icon">article</span>Explicación detallada</a>
                      </span>
                    </span>
                  </span>
                </label>
                <fieldset className="dropdown">                
                  <div className="icon-wrapper">
                    <select id="selectTipoSistemaElectricoInstalacion" onChange={() => actualizarFormularioSensores()}>
                      <option value="MONOFASICO">Monofásico</option>
                      <option value="TRIFASICO">Trifásico</option>                    
                    </select>
                  </div>
                </fieldset>           

                <div className="tabs" style={{marginTop: "10px"}}>
                  <input type="radio" id="instalacionConectada" name="radioTipoInstalacion" defaultChecked="true"/>
                  <label htmlFor="instalacionConectada" onClick={() => mostrarPestañaTipoInstalacion("CONECTADA")}>
                    <span className="label">Tengo contrato eléctrico</span>
                  </label>

                  <input type="radio" id="instalacionDesconectada" name="radioTipoInstalacion"/>
                  <label htmlFor="instalacionDesconectada" onClick={() => mostrarPestañaTipoInstalacion("DESCONECTADA")}>
                    <span className="label">Estoy desconectado de la red eléctrica</span>
                  </label>

                </div>

                <div className="tab-content vertical gap-06" htmlFor="radioTipoInstalacion">

                    <fieldset style={{marginTop: "20px"}}>
                      <fieldset>
                        <span className="size-l">Monitor de consumo de la instalación</span>                        
                        <p id="mensajeIntroMonitor">Aquí debes configurar tu inversor o medidor de consumo del cuadro electrico principal.</p>
                      </fieldset>

                      <fieldset>                      
                        <fieldset id="acometidaPrincipal1FieldsetSinConfigurar">                      
                          <button id="acometidaPrincipal1AddSensorLink" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("acometidaPrincipal1")}><span className="material-icon">add_circle</span><span id="textoBoton1Monitor">Seleccionar dispositivo</span></button>                          
                        </fieldset>

                        <fieldset id="acometidaPrincipal1FieldsetSeleccionado" style={{display: "none"}}>
                          <legend id="tituloAcometidaFase1Configurada">Monitor de consumo de la FASE 1</legend>
                          <div className="selector icon-wrapper no-icon">                          
                            <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("acometidaPrincipal1")}>
                              <figure className="avatar size-m"><AppLogoImg id="acometidaPrincipal1LogoApp" aplicacion={appSensorAP1}/></figure>                          
                              <span id="acometidaPrincipal1Span" className="label"></span>
                            </div>                                                      
                            <input type="text" id="acometidaPrincipal1" style={{display: "none"}}/>
                          </div>
                        </fieldset>

                        <fieldset id="acometidaPrincipal2FieldsetSinConfigurar" className=" hidden">                      
                          <button id="acometidaPrincipal2AddSensorLink" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("acometidaPrincipal2")}><span className="material-icon">add_circle</span>Seleccionar dispositivo para la Fase 2</button>
                        </fieldset>

                        <fieldset id="acometidaPrincipal2FieldsetSeleccionado" style={{display: "none"}}> 
                          <legend>Monitor de consumo de la FASE 2</legend>
                          <div className="selector icon-wrapper no-icon">
                            <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("acometidaPrincipal2")}>
                              <figure className="avatar size-m"><AppLogoImg id="acometidaPrincipal2LogoApp" aplicacion={appSensorAP2}/></figure>
                              <span id="acometidaPrincipal2Span" className="label"></span>
                            </div>                            
                            <input type="text" id="acometidaPrincipal2" style={{display: "none"}}/>
                          </div>
                        </fieldset>

                        <fieldset id="acometidaPrincipal3FieldsetSinConfigurar" className=" hidden">                       
                          <button id="acometidaPrincipal3AddSensorLink" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("acometidaPrincipal3")}><span className="material-icon">add_circle</span>Seleccionar dispositivo para la Fase 3</button>
                        </fieldset>

                        <fieldset id="acometidaPrincipal3FieldsetSeleccionado" style={{display: "none"}}>
                          <legend>Monitor de consumo de la FASE 3</legend>
                          <div className="selector icon-wrapper no-icon">
                            <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("acometidaPrincipal3")}>
                              <figure className="avatar size-m"><AppLogoImg id="acometidaPrincipal3LogoApp" aplicacion={appSensorAP3}/></figure>
                              <span id="acometidaPrincipal3Span" className="label"></span>
                            </div>                            
                            <input type="text" id="acometidaPrincipal3" style={{display: "none"}}/>
                          </div>
                        </fieldset>

                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetInstalacionConectada" className=" hidden" data-content="instalacionConectada">

                      <span className="size-l">Potencias, energía y tarifas</span>      
                    
                      <div id="mensajeTenAManoTuFactura" className="message info left">
                        <h1 className="title"><span className="material-icon">info</span>Configuración automática <span style={{color: "gold"}}>[BETA]</span></h1>
                        <p id="mensajeExcesoVolcadoDesdeRegistro" className="size-s">Carga tu última factura en PDF, revisa los datos autocompletados y edítalos si hace falta.</p>                              
                        <fieldset id="botonLeerPDF" className="horizontal">                
                          <input type="file" id="pdfFactura" name="pdfFactura" accept=".pdf" onChange={() => generarAdjuntoBase64("pdfFactura")}/>
                          <button id="botonSubirPDF" className="button primary" onClick={() => enviarPDF()}>Cargar</button>    
                        </fieldset>
                      </div>                      

                      <details id="datosManualesPotenciaTarifas" className="accordion">
                        
                        <summary className="title">                          
                          <span className="size-s">CONFIGURACIÓN MANUAL</span>
                        </summary>    

                        <ul className="accordion-content vertical gap-04">        

                          <fieldset>
                            <label className="has-tooltip" htmlFor="labelPotenciaContratada">
                              <span className="label tooltip-label">Tarifas de potencia contratada</span>
                              <span className="tooltip-trigger">
                                <span className="material-icon tooltip-icon link size-s">info</span>
                                <span className="tooltip bottom">
                                  <span className="tooltip-container">
                                    <p className="size-m tooltip-title">¿Cuanta potencia tengo contratada?</p>
                                    <p className="size-s">Puedes verlo en tu <strong>factura</strong> de la luz buscando el <strong>apartado "Potencia facturada"</strong>.</p>  
                                    <a href="https://www.ocu.org/vivienda-y-energia/gas-luz/consejos/como-descifrar-la-factura-de-la-luz" target="_blank" className="link size-s"  rel="noopener noreferrer"><span className="material-icon">article</span>Más información</a>                                
                                  </span>
                                </span>
                              </span>
                            </label>
                            
                            <fieldset id="tablaPotenciaContratada" className=" hidden">
                              
                              <input type="text" id="potenciaContratada" className=" hidden"/>
                              <input type="text" id="potenciaActualConfigurada" className=" hidden"/>

                              <div>
                                  <table>
                                      <thead>
                                          <tr className="table-row">                                            
                                              <th className="table-cell" ></th>
                                              <th className="table-cell value">Potencia</th>
                                              <th className="table-cell value">Tarifa</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr id="trPotenciaContratadaP1" className="table-row vertical-start hidden">
                                              <td className="table-cell horizontal gap-02">
                                                  <figure className="avatar size-s cyan"><span className="material-icon">bolt</span></figure>
                                                  <div className="vertical gap-01">
                                                      <span id="spanPotenciaP1">P1 : Punta</span>                                                  
                                                  </div>
                                              </td>
                                              <td id="valorPotenciaContratadaP1" className="table-cell value"></td>
                                              <td id="tarifaPotenciaContratadaP1" className="table-cell value"></td>
                                          </tr>
                                          <tr id="trPotenciaContratadaP2" className="table-row with-divider vertical-start hidden">
                                              <td className="table-cell horizontal gap-02">
                                                  <figure className="avatar size-s cyan"><span className="material-icon">bolt</span></figure>
                                                  <div className="vertical gap-01">
                                                      <span id="spanPotenciaP2">P2 : Llano</span>                                                  
                                                  </div>
                                              </td>
                                              <td id="valorPotenciaContratadaP2" className="table-cell value"></td>
                                              <td id="tarifaPotenciaContratadaP2" className="table-cell value"></td>
                                          </tr>  
                                          <tr id="trPotenciaContratadaP3" className="table-row with-divider vertical-start hidden">
                                              <td className="table-cell horizontal gap-02">
                                                  <figure className="avatar size-s cyan"><span className="material-icon">bolt</span></figure>
                                                  <div className="vertical gap-01">
                                                      <span id="spanPotenciaP3">P3 : Valle</span>                                                  
                                                  </div>
                                              </td>
                                              <td id="valorPotenciaContratadaP3" className="table-cell value"></td>
                                              <td id="tarifaPotenciaContratadaP3" className="table-cell value"></td>
                                          </tr> 
                                          <tr id="trPotenciaContratadaP4" className="table-row with-divider vertical-start hidden">
                                              <td className="table-cell horizontal gap-02">
                                                  <figure className="avatar size-s cyan"><span className="material-icon">bolt</span></figure>
                                                  <div className="vertical gap-01">
                                                      <span>P4 :</span>                                                  
                                                  </div>
                                              </td>
                                              <td id="valorPotenciaContratadaP4" className="table-cell value"></td>
                                              <td id="tarifaPotenciaContratadaP4" className="table-cell value"></td>
                                          </tr> 
                                          <tr id="trPotenciaContratadaP5" className="table-row with-divider vertical-start hidden">
                                              <td className="table-cell horizontal gap-02">
                                                  <figure className="avatar size-s cyan"><span className="material-icon">bolt</span></figure>
                                                  <div className="vertical gap-01">
                                                      <span>P5 :</span>                                                  
                                                  </div>
                                              </td>
                                              <td id="valorPotenciaContratadaP5" className="table-cell value"></td>
                                              <td id="tarifaPotenciaContratadaP5" className="table-cell value"></td>
                                          </tr> 
                                          <tr id="trPotenciaContratadaP6" className="table-row with-divider vertical-start hidden">
                                              <td className="table-cell horizontal gap-02">
                                                  <figure className="avatar size-s cyan"><span className="material-icon">bolt</span></figure>
                                                  <div className="vertical gap-01">
                                                      <span>P6 :</span>                                                  
                                                  </div>
                                              </td>
                                              <td id="valorPotenciaContratadaP6" className="table-cell value"></td>
                                              <td id="tarifaPotenciaContratadaP6" className="table-cell value"></td>
                                          </tr> 
                                      </tbody>
                                  </table>
                              </div>

                            </fieldset>
                            <button  id="botonConfigurarPotencia" rel="noopener noreferrer" target="_self" className="button tertiary" onClick={() => calculadoraPotencia()}>Modificar tarifas de potencia</button>
                          </fieldset>

                          <fieldset>
                            <label className="has-tooltip" htmlFor="labelPrecioCompraKw">
                              <span className="label tooltip-label">Tarifas de compra de energía</span>
                              <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                                <span className="tooltip bottom">
                                  <span className="tooltip-container">
                                    <p className="size-m tooltip-title">¿A cuánto pagas el kWh?</p>
                                    <p className="size-s">Puedes verlo en tu <strong>factura</strong> de la luz en el <strong>apartado "Energía facturada"</strong>.</p>                                
                                    
                                    <a href="https://www.ocu.org/vivienda-y-energia/gas-luz/consejos/como-descifrar-la-factura-de-la-luz" target="_blank" className="link size-s"  rel="noopener noreferrer"><span className="material-icon">article</span>Más información</a>
                                  </span>
                                </span>
                              </span>        
                            </label>

                            <fieldset id="fieldsetPrecioCompraVariable" className="check multiple toggle green">
                              <input type="checkbox" id="checkboxPrecioCompraVariable"  onClick={() => visibilidadTarifasUltimoRecurso()}/>
                              <label className="icon-wrapper has-tooltip" htmlFor="checkboxPrecioCompraVariable" >
                                <span className="label" onClick={(event) => event.preventDefault()}>
                                  <span>TUR / PVPC / Mercado regulado</span>
                                  <span className="tooltip-trigger">
                                    <span className="material-icon tooltip-icon link size-s">info</span>
                                    <span className="tooltip top">
                                      <span className="tooltip-container"><p className="size-m tooltip-title">¿TUR / PVPC / Mercado regulado?</p>
                                      <p className="size-s">El mercado regulado / TUR / PVPC es un sistema de precios que regula el gobierno y que cambia cada hora. Si no sabes si estás con una comercializadora de mercado regulado <strong>revisa tu factura y mira si en el apartado "Tipo de contrato" aparece alguna de estas palabras "TUR", "PVPC" , "Mercado regulado"</strong>, si alguna aparece marca esta opción.</p></span>
                                    </span>
                                  </span>
                                </span>
                              </label>
                            </fieldset>

                            <fieldset id="tablaTarifasContratadas" className=" ">
                              
                              <input type="text" id="precioCompraKw" className=" hidden"/>

                              <div>
                                <table>
                                    <thead id="theadTarifasEnergia" className=" hidden">
                                        <tr className="table-row">                                            
                                            <th className="table-cell" ></th>                                        
                                            <th className="table-cell value">Tarifa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr id="trTarifaEnergiaP1" className="table-row vertical-start hidden">
                                            <td className="table-cell horizontal gap-02">
                                                <figure className="avatar size-s cyan"><span className="material-icon">euro</span></figure>
                                                <div className="vertical gap-01">
                                                    <span id="spanTarifaP1">P1 : Punta</span>                                                  
                                                </div>
                                            </td>                                        
                                            <td id="tarifaEnergiaP1" className="table-cell value"></td>
                                        </tr>
                                        <tr id="trTarifaEnergiaP2" className="table-row with-divider vertical-start hidden">
                                            <td className="table-cell horizontal gap-02">
                                                <figure className="avatar size-s cyan"><span className="material-icon">euro</span></figure>
                                                <div className="vertical gap-01">
                                                    <span id="spanTarifaP2">P2 : Llano</span>                                                  
                                                </div>
                                            </td>                                        
                                            <td id="tarifaEnergiaP2" className="table-cell value"></td>
                                        </tr>  
                                        <tr id="trTarifaEnergiaP3" className="table-row with-divider vertical-start hidden">
                                            <td className="table-cell horizontal gap-02">
                                                <figure className="avatar size-s cyan"><span className="material-icon">euro</span></figure>
                                                <div className="vertical gap-01">
                                                    <span id="spanTarifaP3">P3 : Valle</span>                                                  
                                                </div>
                                            </td>                                        
                                            <td id="tarifaEnergiaP3" className="table-cell value"></td>
                                        </tr>                                     
                                        <tr id="trTarifaEnergiaP4" className="table-row with-divider vertical-start hidden">
                                            <td className="table-cell horizontal gap-02">
                                                <figure className="avatar size-s cyan"><span className="material-icon">euro</span></figure>
                                                <div className="vertical gap-01">
                                                    <span id="spanTarifaP4">P4 :</span>                                                  
                                                </div>
                                            </td>                                        
                                            <td id="tarifaEnergiaP4" className="table-cell value"></td>
                                        </tr>   
                                        <tr id="trTarifaEnergiaP5" className="table-row with-divider vertical-start hidden">
                                            <td className="table-cell horizontal gap-02">
                                                <figure className="avatar size-s cyan"><span className="material-icon">euro</span></figure>
                                                <div className="vertical gap-01">
                                                    <span id="spanTarifaP5">P5 :</span>                                                  
                                                </div>
                                            </td>                                        
                                            <td id="tarifaEnergiaP5" className="table-cell value"></td>
                                        </tr>   
                                        <tr id="trTarifaEnergiaP6" className="table-row with-divider vertical-start hidden">
                                            <td className="table-cell horizontal gap-02">
                                                <figure className="avatar size-s cyan"><span className="material-icon">euro</span></figure>
                                                <div className="vertical gap-01">
                                                    <span id="spanTarifaP6">P6 :</span>                                                  
                                                </div>
                                            </td>                                        
                                            <td id="tarifaEnergiaP6" className="table-cell value"></td>
                                        </tr>   
                                    </tbody>
                                </table>
                              </div>
                              
                              <button id="botonConfigurarTarifas" rel="noopener noreferrer" target="_self" className="button tertiary" onClick={() => calculadoraTarifaCompra()}>Modificar tarifas de energía</button>
                              
                            </fieldset>
                      
                          </fieldset>

                          <fieldset className="two-columns tooltip-parent">

                            <fieldset >
                              <label className="has-tooltip" htmlFor="labelDiaInicioFacturacion">
                                <span className="label tooltip-label">Día inicio facturación</span>
                                <span className="tooltip-trigger">
                                <span className="material-icon tooltip-icon link size-s">info</span>
                                  <span className="tooltip bottom">
                                    <span className="tooltip-container">
                                      <p className="size-m tooltip-title">¿Día de inicio de facturación?</p>
                                      <p className="size-s">Es el día que empieza tu facturación cada mes. Busca en tu factura el <strong>apartado "periodo de facturación" y pon el día "desde" que indica</strong>. Normalmente los periodos de facturación empiezan el día 1 de cada mes.</p>                                
                                    </span>
                                  </span>
                                </span>
                              </label>

                              <fieldset className="icon-wrapper data">
                                <input type="text" pattern="\d*" maxLength="2" id="diaInicioFacturacion" onInput={() => validarDiaInicioFacturacion()} placeholder="Ej: 1"/>
                              </fieldset>
                            </fieldset>

                            <fieldset >
                              <label className="has-tooltip" htmlFor="labelDescuentoEnFactura">
                                <span className="label tooltip-label">Descuento en factura</span>
                                <span className="tooltip-trigger">
                                <span className="material-icon tooltip-icon link size-s">info</span>
                                  <span className="tooltip bottom">
                                    <span className="tooltip-container">
                                      <p className="size-m tooltip-title">¿Tienes algún descuento?</p>
                                      <p className="size-s">En ocasiones las comercializadoras aplican descuentos a tu consumo, revisa tu factura e indica el % de descuento que te aplica en caso de que lo tengas.</p>                                
                                      <a href="https://www.ocu.org/vivienda-y-energia/gas-luz/consejos/como-descifrar-la-factura-de-la-luz" target="_blank" className="link size-s"  rel="noopener noreferrer"><span className="material-icon">article</span>Más información</a>
                                    </span>
                                  </span>
                                </span>
                              </label>

                              <fieldset className="icon-wrapper data" data-label="%">
                                <input type="text" inputMode="decimal" id="descuentoEnFactura"/>
                              </fieldset>
                            </fieldset>

                          </fieldset>

                        </ul>
                      </details>

                    </fieldset>                    

                </div>
                
              </fieldset>

            </fieldset>
          </form>

          <FormValidationError/>

          <WorkflowNavigationButtons step={"GENERAL_INFO_USER"} navegar={navegar}/>

        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }      

      <Loader Id="loaderGeneralInfo" Mensaje=""/>

      </section>
      
      <AsideMenu selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>

    </main>
    
  )
}

export default GeneralInfo